import { toast } from 'sonner';
import { parseBackendError } from '@/libs/utils/parseBackendErrors';

const DEFAULT_FALLBACK_MESSAGE = 'Something went wrong';

/**
 * Single entry point for surfacing a failed mutation to the user.
 *
 * A rejection reaching a TanStack `onError` is typed `unknown` and is not
 * guaranteed to be an `Error`: reading `err.message` blindly toasts
 * `undefined`, hiding the failure from the analyst. Narrowing happens here
 * once so every call site gets the same robust behaviour.
 *
 * @param err - The rejection value, as handed to `onError`.
 * @param fallbackMessage - Copy used when `err` carries no usable message.
 */
export function toastBackendError(err: unknown, fallbackMessage = DEFAULT_FALLBACK_MESSAGE): void {
  const raw = err instanceof Error ? err.message : typeof err === 'string' ? err : fallbackMessage;

  toast.error(parseBackendError(raw).concatMsg);
}
